import styled, { createGlobalStyle } from 'styled-components';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { Text } from '@components/typography';
import { themeSpace, themeColor, themeMediaQuery, themeVariant } from '@utils/styledTheme.util';

export const OverWriteOverflowX = createGlobalStyle`
  .react-horizontal-scrolling-menu--scroll-container {
    --scrollbarBG: rgba(247, 247, 247, 1);
    --thumbBG: rgba(224, 224, 224, 1);
    gap: ${themeSpace(3)};
    padding: 0px ${themeSpace(9)};
    ${themeMediaQuery('below_sm')} {
      padding: 0px ${themeSpace(8)};
      gap: ${themeSpace(2)};
    }
  }
  .react-horizontal-scrolling-menu--scroll-container::-webkit-scrollbar {
    height: ${themeSpace(3)};
    width: ${themeSpace(3)};
    ${themeMediaQuery('below_sm')} {
      display: none;
    }
  }
  .react-horizontal-scrolling-menu--scroll-container {
    scrollbar-width: ${themeSpace(3)};
    scrollbar-color: var(--thumbBG) var(--scrollbarBG);
  }
  .react-horizontal-scrolling-menu--scroll-container::-webkit-scrollbar-track {
    border-radius: ${themeSpace(3)};
    background: var(--scrollbarBG);
    margin: 0px ${themeSpace(9)};
    ${themeMediaQuery('below_sm')} {
      margin: 0px ${themeSpace(8)};
    }
  }
  .react-horizontal-scrolling-menu--scroll-container::-webkit-scrollbar-thumb {
    background-color: var(--thumbBG) ;
    border-radius: ${themeSpace(3)};
    margin: 0px ${themeSpace(9)};
    ${themeMediaQuery('below_sm')} {
      margin: 0px ${themeSpace(8)};
    }
  }
  .react-horizontal-scrolling-menu--wrapper {
    position: relative;
  }
`;

export const SliderWrapper = styled(Box)`
  max-width: 2368px;
`;

export const StyledText = styled(Text)`
  ${themeMediaQuery('below_sm')} {
    ${themeVariant('featureHed17')};
  }
`;

export const ItemWrapper = styled(Box)`
  width: 100%;
`;

export const SwiperButton = styled(Flex)<{ hide: boolean }>`
  cursor: pointer;
  border-radius: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  height: 48px;
  width: 48px;
  box-shadow: 0px 7px 27px ${themeColor('neutra6', 0.06)}, 0px 4px 16px rgba(0, 0, 0, 0.07);
  position: absolute;
  top: 40%;
  z-index: 2;
  display: ${({ hide }) => (hide ? 'none' : 'flex')};
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const SwiperButtonLeft = styled(SwiperButton)`
  left: ${themeSpace(7)};
`;

export const SwiperButtonRight = styled(SwiperButton)`
  right: ${themeSpace(7)};
`;
